export class Contact {
    From: string;
    Subject: string;
    Content: string;
}
